import { lazy } from "react";
import { PlanCard, PlanName, PlanPrice, PerkList } from "./styles";
const Container = lazy(() => import("../../common/Container"));

const vipPerks = [
  "VIP tag",
  "Messages are visible in events feed",
  "Vote for kick (3 VIP votes needed)",
  "Double jump",
  "Starting balance: $5k",
  "Money multiplier: 1.25x",
  "VIP Zombie",
  "VIP Knife in deathrun",
];

const Subscriptions = () => {
  return (
    <Container>
      <h6>In-game subscriptions</h6>
      <PlanCard>
        <PlanName>VIP</PlanName>
        <PlanPrice>
          $2.99<span>/month</span>
        </PlanPrice>
        <PerkList>
          {vipPerks.map((perk) => (
            <li key={perk}>{perk}</li>
          ))}
        </PerkList>
        {/* <BlackTypography variant="body1" display="inline">
You can learn how to buy VIP here:
        </BlackTypography>
        <NavLink
          to="/CryptoPayment"
        > Crypto Payment</NavLink>
        <BlackTypography variant="h3" align="left" paddingTop={5}>
          Account balance
        </BlackTypography>
        <BlackTypography variant="body1" paddingTop={5}>
- You can check your account balance by typing in chat ‘/balance’
        </BlackTypography>
        <BlackTypography variant="body1">
- You can buy VIP by typing in chat ‘/buy_vip’
        </BlackTypography>
        <BlackTypography variant="h3" align="left" paddingTop={5}>
          Crypto Wallets
        </BlackTypography>
        <BlackTypography variant="body1" paddingTop={5}>
<img src="/img/icons/cardano.png" width={20}/> ADA: <a>addr1q8afu4jjjf4u75a23v8tqgjharhte06uekv9eks6cq4lmhkutqcz2x5merdxv6wtz6w0wqjcj2xr2py4td0akqnzen7s27vs0z</a>
        </BlackTypography>
        <BlackTypography variant="body1" paddingTop={2}>
<img src="/img/icons/ethereum.png" width={18}/> ETH: <a>0x20181376BcE7830D9449f1392405962E47BBACEf</a>
        </BlackTypography>
        <BlackTypography variant="body1" paddingTop={2} paddingBottom={5}>
<img src="/img/icons/polygon.png" width={20}/> MATIC (Polygon Network): <a>0x20181376BcE7830D9449f1392405962E47BBACEf</a>
        </BlackTypography> */}
      </PlanCard>
    </Container>
  );
};

export default Subscriptions;
